import { render, staticRenderFns } from "./ConfirmDialog.vue?vue&type=template&id=68b1c5d0&scoped=true"
import script from "./ConfirmDialog.vue?vue&type=script&lang=ts"
export * from "./ConfirmDialog.vue?vue&type=script&lang=ts"
import style0 from "./ConfirmDialog.vue?vue&type=style&index=0&id=68b1c5d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b1c5d0",
  null
  
)

export default component.exports